module.exports = __webpack_public_path__ + "static/media/bg_Page01.802c1dba.jpg";